/**
 * Icon used in sections of the Home Page.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright (c) Ircam Amplify 2025
 */

import './styles/HomePageIcon.css'

/**
 * Props for HomePageIcon
 */
interface HomePageIconProps {
  src: string
  alt: string
  background?: string
}

/**
 * Icon used in sections of the Home Page.
 */
const HomePageIcon = (props: HomePageIconProps) => {
  return (
    <div
      className="homePageIcon-container"
      style={{ background: props.background }}
    >
      <img className="icon" src={props.src} alt={props.alt} />
    </div>
  )
}

export default HomePageIcon
